import { render, staticRenderFns } from "./RequirementList.vue?vue&type=template&id=604f3e65"
import script from "./RequirementList.vue?vue&type=script&lang=js"
export * from "./RequirementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports